import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Observable, map, tap } from 'rxjs';
import { LotDetailsService } from 'src/app/services/lot-details.service';
import { NegotiationActionsService } from 'src/app/services/negotiation-actions.service';
import { Lot, PriceType } from '../../bids-and-offers/lots.model';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarModule,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { LotsService } from 'src/app/services/lots.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PriceTypePipe } from 'src/app/pipes/price-type.pipe';
import { LoadingSpinnerComponent } from '../../custom/loading-spinner/loading-spinner.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-new-negotiation',
  templateUrl: './new-negotiation.component.html',
  styleUrls: ['./new-negotiation.component.css'],
  standalone: true,
  imports: [
    LoadingSpinnerComponent,
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
    PriceTypePipe,
  ],
})
export class NewNegotiationComponent implements OnInit {
  lot$: Observable<Lot>;
  newNegotiation: FormGroup;
  isLoading: boolean;
  negotiationTitle: string;
  origPriceType = signal<PriceType>(null);

  constructor(
    private route: ActivatedRoute,
    private lotDetailsService: LotDetailsService,
    private lotsService: LotsService,
    private negotiationActionsService: NegotiationActionsService,
    private location: Location,
    private snackbar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    let lotId = this.route.snapshot.paramMap.get('id');
    // console.log(lotId)
    this.lot$ = this.lotDetailsService
      .watch({
        itemId: lotId,
      })
      .valueChanges.pipe(
        // tap(res => console.log('data lot',res)),
        map((result) => {
          let price: number;
          if (this.lotsService.isCashPrice(result.data.lot.price)) {
            this.origPriceType.set(PriceType.Cash);
            price = +this.lotsService.getPriceText(result.data.lot.price);
          } else {
            this.origPriceType.set(PriceType.Basis);
          }
          this.isLoading = false;
          this.negotiationTitle = `${result.data.lot.commodity} - ${result.data.lot.grade}`;

          this.newNegotiation = new FormGroup({
            lot_id: new FormControl(lotId), // string,
            price_type: new FormControl<PriceType>(
              this.origPriceType(),
              Validators.required
            ),
            cash_price: new FormGroup({
              amount: new FormControl(price),
            }),
            volume_value: new FormControl(
              result.data.lot.volume_value,
              Validators.required
            ),
            ship_begin: new FormControl(result.data.lot.ship_begin),
            ship_end: new FormControl(result.data.lot.ship_end),
            // TODO : implement basisPricing
            // basis_price: new FormGroup({
            //   month: new FormControl<string>(null),
            //   year: new FormControl<number>(null),
            //   product_code: new FormControl<string>(null),
            //   basisPoints: new FormControl<number>(null),
            // }),
            // status: new FormControl(null),
          });
          return result.data.lot;
        })
      );
  }

  onSubmit() {
    // this.negotiationActionsService.createNegotiation()
    if (this.newNegotiation.valid) {
      this.negotiationActionsService
        .createNegotiation(this.newNegotiation.value)
        .subscribe({
          next: (result) => {
            this.snackbar.open(
              `Created Negotiation for ${this.negotiationTitle}`,
              null,
              { panelClass: ['blue-snackbar'], duration: 3000 }
            );
            this.location.back();
          },
          error: (err) => {
            console.error('Error creating negotiation:', err.message);
          },
        });
    }
  }
}
